import { z } from 'zod'

/**
 * Motivos de baja de un cliente (ORR-404).
 *
 * La lista vive acá y no en una tabla de catálogo: Lisandro pidió el dato en la ficha
 * y descartó agruparlo o reportarlo, así que sumar un motivo es una línea más y un deploy,
 * no un CRUD. `clientes.motivo_baja` guarda el `value` sin CHECK, y el front es su único
 * escritor.
 */
export const MOTIVOS_BAJA = [
  { value: 'demasiado_caro', label: 'Demasiado caro' },
  { value: 'mal_servicio', label: 'No siente que sea buen servicio' },
  { value: 'enojo_puntual', label: 'Enojo por algún tema puntual' },
  { value: 'no_necesita', label: 'No necesitará más el servicio' },
  { value: 'no_contesta', label: 'No contesta' },
  { value: 'deuda_mayor_3_meses', label: 'Deuda mayor a 3 meses' },
  { value: 'otros', label: 'Otros' },
] as const

export type MotivoBaja = (typeof MOTIVOS_BAJA)[number]['value']

const VALORES = MOTIVOS_BAJA.map((m) => m.value) as [MotivoBaja, ...MotivoBaja[]]

/** Etiqueta para mostrar. Un valor viejo o desconocido se devuelve tal cual antes que romper la ficha. */
export const labelMotivoBaja = (value: string | null | undefined): string | null => {
  if (!value) return null
  return MOTIVOS_BAJA.find((m) => m.value === value)?.label ?? value
}

export const motivoBajaSchema = z
  .object({
    motivo: z.enum(VALORES, { message: 'Elegí un motivo' }),
    detalle: z.string().nullable().optional(),
  })
  // "Otros" sin texto no dice nada: es el motivo que se lleva todo lo que no entra en la lista,
  // y sin detalle el registro nace muerto.
  .refine((val) => val.motivo !== 'otros' || (val.detalle?.trim().length ?? 0) > 0, {
    path: ['detalle'],
    message: 'Contá brevemente el motivo',
  })

export type MotivoBajaFormValues = z.infer<typeof motivoBajaSchema>
